import RefClient from 'ref-client-core';
import centerMap from './centerMap';
import locationOriginalLocationDiffRoutes from './locationOriginalLocationDiffRoutes';

RefClient.mapPlugin.register('centerMap', centerMap);
RefClient.mapPlugin.register(
  'locationOriginalLocationDiffRoutes',
  locationOriginalLocationDiffRoutes
);
